import { isBefore } from "date-fns";

export const getEarlyHoursEvents = (events, morningStart) => {
  const earlyHoursEvents = events?.filter((event) =>
    isBefore(new Date(event?.["startedAt"]), morningStart)
  );
  return earlyHoursEvents;
};
